import { Divider } from "@frends/ui-components/react";

export default Divider;
